// extracted by mini-css-extract-plugin
export default {"section":"section__section-NjJdA","header":"section__header-QPxWb"};